import * as angular from 'angular';

import { ComponentDefinition } from '../../models';

class FileChooserModalOpenerController implements angular.IComponentController {
    controlId: string;
    defaultFilename: string;
    displayFilename: string;
    fileBase64: string;
    fileList: FileList;
    filename: string;
    types: string;

    static $inject = [];
}

export const wtFileChooserModalOpener: ComponentDefinition = {
    componentId: 'wtFileChooserModalOpener',
    controller: FileChooserModalOpenerController,
    template: require('./fileChooserModalOpener.component.html'),
    controllerAs: 'vm',
    bindings: {
        fileList: '=',
        controlId: '@',
        types: '@',
        filename: '<',
        fileBase64: '<'
    }
};